export default __webpack_public_path__ + "static/media/suite_b757.2e725c49.mp4";